/**
 * @since 2018/9/5
 * @author fanjingjian
 */

const DATA_CENTER_PORTAL_PATH = '/manage/sales/api';

export { DATA_CENTER_PORTAL_PATH };
export const SSO_LOCATION_FOR_LOGIN = `${_SSO_LOCATION_FOR_LOGIN_HOST}?client_id=${_KIT_SSO_CLIENT_ID}&redirect_uri=`;
export const SSO_CALLBACK_PATH_FOR_LOGIN = '#/sso/callback';
export const SSO_COOKIE_KEY_FOR_CALLBACK_PAGE = `${_KIT_SSO_CLIENT_ID}_CURRENT_URL`;

export const QC_PLATFORM_IMAGE_UPLOAD_PATH_ACTION = `${DATA_CENTER_PORTAL_PATH}/images`;

export const MULTI_FAKE_INFO_PAGE_WITHOUT_SEARCH_WRAPPER = [
  '/errors/multi-fake-info',
  '/errors/multi-fake-info-download',
  '/errors/multi-parent',
  '/errors/special-business-time',
  '/errors/batch-brand-shop-list',
  '/errors/repeat/batch-split-shop',
];
